import { render, staticRenderFns } from "./TokenTracking.vue?vue&type=template&id=8b1f80fc&scoped=true"
import script from "./TokenTracking.vue?vue&type=script&lang=js"
export * from "./TokenTracking.vue?vue&type=script&lang=js"
import style0 from "./TokenTracking.vue?vue&type=style&index=0&id=8b1f80fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1f80fc",
  null
  
)

export default component.exports